module.exports = __webpack_public_path__ + "static/media/news-chief-legal-officer.274d7a44.jpg";